import React from 'react';
import PropTypes from 'prop-types';
import useClassNames from '@medflex/hooks/useClassNames';

export const KINDS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SIGNAL: 'signal',
  WARNING: 'warning',
  ALERT: 'alert',
  SUCCESS: 'success',
};

const kinds = {
  [KINDS.PRIMARY]: 'bg-blue-200 text-blue-800',
  [KINDS.SECONDARY]: 'bg-slate-200 text-slate-800',
  [KINDS.SIGNAL]: 'bg-teal-200 text-teal-800',
  [KINDS.SUCCESS]: 'bg-green-200 text-green-800',
  [KINDS.WARNING]: 'bg-orange-200 text-orange-800',
  [KINDS.ALERT]: 'bg-red-200 text-red-800',
};

export const SIZES = {
  BASE: 'base',
  SMALL: 'small',
};

const Badge = ({ kind, className, children, hidden = false, size = SIZES.BASE }) => {
  const cn = useClassNames(
    () => [
      hidden ? 'hidden' : 'inline-flex',
      'whitespace-no-wrap',
      'rounded-full',
      'text-sm',
      size === SIZES.BASE && ['py-1', 'px-2.5'],
      size === SIZES.SMALL && ['py-0.5', 'px-2'],
      'font-semibold',
      kinds[kind],
      className,
    ],
    [className, kind],
  );

  return (
    <div data-component="Badge" className={cn}>
      {children}
    </div>
  );
};

Badge.defaultProps = {
  kind: KINDS.PRIMARY,
  size: SIZES.BASE,
  hidden: false,
  className: '',
  children: null,
};

Badge.propTypes = {
  children: PropTypes.node,
  kind: PropTypes.oneOf(Object.values(KINDS)),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  hidden: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(SIZES)),
};

export default Badge;
